const $productSelect = $("#product-select"),
      $productSelectContainer = $("#product-select-container"),
      $productListContainer = $('#product-list-container'),
      productColorMap = {
          'leap': 'purple',
          'go': 'yellow',
      }

let   DEFAULT_PRODUCT = '';

const updateState = id => {
    updateProductVisibility(id);
    updateNavigation(id);
    handleColorChange(id);
}

const updateProductVisibility = id => {
    $(`[data-product]`).hide();
    $(`[data-product="${id}"]`).show();
}

const updateURL = id => {
    let href = window.location.href;
    window.location.href = href.split('#')[0] + `#${id}`;
}

const handleColorChange = (product) => {
    let color = productColorMap[product] || '';
    $('.select2-selection').attr('data-color', color);
}

const updateNavigation = id => {
    $productListContainer.find(`[href]`).each((index, element) => element.classList.remove('active'))
    $productListContainer.find(`[href="#${id}"]`).addClass('active');
    $productSelect.val(`${id}`).trigger('change');
}

const checkHash = () => {
     updateState(window.location.hash ? window.location.hash.substring(1) : DEFAULT_PRODUCT)
}

const formatState = (state) => {
    if (!state.id) return state.text;
    return $(`<div class="text-wrap"><span class="font-size-12 fw-bold text-uppercase">${state.text}</span><br>${state.element.dataset.text || ""}</div>`);
}

$productSelect.select2({
    width: '100%',
    dropdownParent: $productSelectContainer,
    minimumResultsForSearch: -1,
    theme: 'default select-fw-normal',
    templateResult: formatState,
    templateSelection: formatState
})

$productSelect.on('select2:select', () => {
    let productName = $productSelect.val();
    updateURL(productName)
    handleColorChange(productName);
});

window.addEventListener('popstate',  () => checkHash());

checkHash();


